
//// LOCAL
//export const base_url = 'http://localhost:1341'
//export const img_base_url = 'http://localhost:1341'  //IMAGE URL FOR SAILS SERVER

//// JDD TEST
////export const base_url = 'https://resto-back.evolutiosystem.com'
//export const img_base_url = 'https://resto-back.evolutiosystem.com'  //IMAGE URL FOR SAILS SERVER

//// JDD TEST LOGI PRL
//export const base_url = 'https://jdd-back.logicielperlene.com'
//export const img_base_url = 'https://jdd-back.logicielperlene.com'  //IMAGE URL FOR SAILS SERVER

//// PRL DG DEMO
//export const base_url = 'https://resto-back.evolutiosystem.com'
//export const img_base_url = 'https://resto-back.evolutiosystem.com'  //IMAGE URL FOR SAILS SERVER

//// FATOU FROZEN
//export const base_url = 'https://fatou-back.evolutiosystem.com'
//export const img_base_url = 'https://fatou-back.evolutiosystem.com'  //IMAGE URL FOR SAILS SERVER






//export const base_url = ' https://jdd-perlene.herokuapp.com' https://resto-back.evolutiosystem.com

// const base_url = ' https://jdd-test.herokuapp.com'
//export const base_url ='http://logicielperlene.com/app'

//////export const img_base_url = 'http://192.168.10.49:5000'  //IMAGE URL FOR EXPRESS
///export const img_base_url = 'https://resto-img.evolutiosystem.com'  //IMAGE URL FOR ONLINE SERVER


/// ENVIRONNEMENT REEL

//// FATOU FROZEN
//export const base_url = 'https://back-fatou.perlenedg.com'
//export const img_base_url = 'https://back-fatou.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// LA MARTINE
//export const base_url = 'https://martine-back.evolutiosystem.com'
//export const img_base_url = 'https://martine-back.evolutiosystem.com'  //IMAGE URL FOR SAILS SERVER

//// AGRO DYNAMIQUE
//export const base_url = 'https://agrodynamique-back.perlenedg.com'
//export const img_base_url = 'https://agrodynamique-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// LOLO ANDOCHE
//export const base_url = 'https://loloandoche-back.perlenedg.com'
//export const img_base_url = 'https://loloandoche-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// HELLO PHONE
//export const base_url = 'https://hellophone-back.perlenedg.com'
//export const img_base_url = 'https://hellophone-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// OLOYEDE MARKET
//export const base_url = 'https://oloyedemarket-back.perlenedg.com'
//export const img_base_url = 'https://oloyedemarket-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// GOD GRACE DISTRIBUTION
//export const base_url = 'https://ggd-back.perlenedg.com'
//export const img_base_url = 'https://ggd-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER


//// STATION CONTINUE
//export const base_url = 'https://stationcontinue-back.perlenedg.com'
//export const img_base_url = 'https://stationcontinue-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// HALAL
//export const base_url = 'https://halal-back.perlenedg.com/'
//export const img_base_url = 'https://halal-back.perlenedg.com/'  //IMAGE URL FOR SAILS SERVER

//// MZ DISTRIBUTION
//export const base_url = 'https://mzdistribution-back.perlenedg.com'
//export const img_base_url = 'https://mzdistribution-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER


//// DONAN LAKSHMI
//export const base_url = 'https://donanlakshmi-back.perlenedg.com'
//export const img_base_url = 'https://donanlakshmi-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// BR ABIALA https://prldg-back.perlenerestaurant.com/
//export const base_url = 'https://br-abiala-back.perlenedg.com'
//export const img_base_url = 'https://br-abiala-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// NEW PRL DG /
//export const base_url = 'https://prldg-back.perlenerestaurant.com'
//export const img_base_url = 'https://prldg-back.perlenerestaurant.com'  //IMAGE URL FOR SAILS SERVER

//// NEW FATOU FROZEN /
//export const base_url = 'https://perlenedg-back.fatoufrozen.com'
//export const img_base_url = 'https://perlenedg-back.fatoufrozen.com'  //IMAGE URL FOR SAILS SERVER

//// FATOU FROZEN
//export const base_url = 'https://fatoudg.perlenecommande.com'
//export const img_base_url = 'https://fatoudg.perlenecommande.com'  //IMAGE URL FOR SAILS SERVER

//// NOSITO /
//export const base_url = 'https://nosito-back.perlenedg.com'
//export const img_base_url = 'https://nosito-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// CELEBRITE /
//export const base_url = 'https://celebrite-back.perlenedg.com'
//export const img_base_url = 'https://celebrite-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// DEMO PELENE RESTAURANT /
//export const base_url = 'https://perlene-back.perlenecommande.com'
//export const img_base_url = 'https://perlene-back.perlenecommande.com'  //IMAGE URL FOR SAILS SERVER

//// BAHAAU /
//export const base_url = 'https://bahaau-back.perlenecommande.com'
//export const img_base_url = 'https://bahaau-back.perlenecommande.com'  //IMAGE URL FOR SAILS SERVER

//// LA PERFECTION TOGO /
//export const base_url = 'https://laperfection-back.perlenecommande.com'
//export const img_base_url = 'https://laperfection-back.perlenecommande.com'  //IMAGE URL FOR SAILS SERVER

//// ELEMIAH TRADING /
//export const base_url = 'https://elemiah-back.perlenedg.com'
//export const img_base_url = 'https://elemiah-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// MILFLEUR /
//export const base_url = 'https://milfleur-back.perlenedg.com'
//export const img_base_url = 'https://milfleur-back.perlenedg.com'  //IMAGE URL FOR SAILS SERVER

//// pilh sc /
//export const base_url = 'https://pilhsc-back.perlenedg.com'
//export const img_base_url = 'https://pilhsc-back.perlenedg.com'  

//// CARESSE CARE/
//export const base_url = 'https://caressecare-back.perlenedg.com'
//export const img_base_url = 'https://caressecare-back.perlenedg.com'  

//// ODILON/
//export const base_url = 'https://odilon-back.perlenedg.com'
//export const img_base_url = 'https://odilon-back.perlenedg.com'  
//export const use_logiciel = 'NO' // YES or NO

//// COHEN SHOP/
//export const base_url = 'https://cohenshop-back.perlenedg.com'
//export const img_base_url = 'https://cohenshop-back.perlenedg.com'  
//export const use_logiciel = 'NO' // YES or NO

//// PERLENE DEMO/
//export const base_url = 'https://degueds-back.perlenecommande.com'
//export const img_base_url = 'https://degueds-back.perlenecommande.com'  
//export const use_logiciel = 'NO' // YES or NO

//// ARODOD/
//export const base_url = 'https://arodod-back.perlenedg.com'
//export const img_base_url = 'https://arodod-back.perlenedg.com'  
//export const use_logiciel = 'NO' // YES or NO

//// FABIK/
export const base_url = 'https://fabik-back.perlenedg.com'
export const img_base_url = 'https://fabik-back.perlenedg.com'  
//export const use_logiciel = 'NO' // YES or NO

// PARAMETRES

export const use_logiciel = 'NO' // YES or NO
export const is_GestionMesure = 'NO' // YES or NO